import veritoneApi from './veritoneApi';

export function fetchSubRegions (urlApi, objQuery) {
    const { parentId, selectionType } = objQuery;
    const payload = parentId === 'world' ? { type: 'Country'} : { parentId, selectionType };
    return veritoneApi(urlApi.baseUrl)
    .post (`${urlApi.campaign}/dataLocation/geofence`, payload)
    .then (response => response.data)
    .catch (error => error);
}

export function geoFencingSearchLocationApi(urlApi, objQuery) {
    const { searchValue, selectionType, unratedLocationIds = [] } = objQuery;
    const payload = {
        locationName: searchValue,
        selectionType,
        unratedLocationIds
    }
    return veritoneApi(urlApi.baseUrl)
    .post(`${urlApi.campaign}/dataLocation/geofence`, payload)
    .then(response => response.data)
    .catch(error=> error)
}

export function geoFencingSavedLocationApi(urlApi, objQuery) {
    const { selectedIdData, selectionType } = objQuery;
    const payload = {
        selectionType,
        locationIds: selectedIdData
    }
    return veritoneApi(urlApi.baseUrl)
    .post(`${urlApi.campaign}/dataLocation/geofence`, payload)
    .then(response => response.data)
    .catch(error=> error)
}
//TODO: double check & delete this since we are not using it
// export function fetchLocations(urlApi, ids) {
//     return veritoneApi(urlApi.baseUrl)
//     .get(`${urlApi.campaign}/dataLocation/geolocation?ids=${ids}`)
//     .then(response => response.data)
//     .catch(error=> error)
// }